




















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Icons extends Vue {
  @Prop({ type: String, default: 'winner' })
  readonly type!: string;

  @Prop({ type: String, default: 'a' })
  readonly url!: string;

  get iconType(): string {
    return `icon__img_${this.type}`;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/progress/components/result/components/progress/components/icons/Icons.vue